'use strict';

// フォームの開閉項目（shared/form/_collapsible_field）
// 見出しのボタンで中身を開閉し、キャレットの向きと aria-expanded を揃える。
// document へのイベント委譲なので turbolinks:load の外で1回だけ登録する（中で登録すると遷移のたびに重複する）。

$(document).on('click', '.js-form-collapsible-toggle', function () {
  const $toggle = $(this);
  const $details = $toggle.closest('.js-form-collapsible').find('.js-form-collapsible-details').first();
  const willOpen = !$details.is(':visible');

  $details.slideToggle(200);
  $toggle.attr('aria-expanded', String(willOpen));
  $toggle.find('i').first()
    .toggleClass('fa-caret-down', willOpen)
    .toggleClass('fa-caret-right', !willOpen);
});
